import React from 'react'
import { ActivityIndicator, View, StyleSheet } from 'react-native'
import { colorsDEPRECATED } from '@pff-consumer/core-ui'
import { SVGGroup } from '@pff-consumer/utils/lib/svg/svg-group'
import { Icon } from '../../atoms/icon'
import { useStyles } from './loading-pane.style'
import type { LoadingPaneProps } from './loading-pane.props'

export const LoadingPane = (props: LoadingPaneProps) => {
  const { isLoading } = props
  const styles = useStyles()

  if (!isLoading) {
    return null
  }

  return (
    <View
      style={styles.container}
      testID='loadingPane'
    >
      <Icon
        group={SVGGroup.Icons}
        name='pff-logo'
        style={StyleSheet.flatten(styles.logo)}
      />
      <View style={styles.indicator}>
        <ActivityIndicator
          size='large'
          color={colorsDEPRECATED.aqua}
        />
      </View>
    </View>
  )
}
